// Design tokens — now backed by CSS custom properties so themes swap at
// runtime. The actual values live in src/index.css under :root (dark, default)
// and html[data-theme="light"]. Components keep using these same JS references.
//
// Caveat for icons: a CSS var works in CSS *property* values (style props,
// templates) but NOT in an SVG presentation *attribute*. So lucide icons must
// be colored via `style={{ color: token }}` (currentColor), never `color={token}`.

const v = (name) => `var(--tc-${name})`;

export const color = {
  bg: { base: v('bg-base'), input: v('bg-input'), surface: v('bg-surface'), raised: v('bg-raised') },
  text: {
    heading: v('text-heading'), primary: v('text-primary'), secondary: v('text-secondary'),
    muted: v('text-muted'), subtle: v('text-subtle'), faint: v('text-faint'), onAccent: v('text-on-accent'),
  },
  border: { default: v('border-default'), subtle: v('border-subtle') },
  accent: { primary: v('accent-primary'), light: v('accent-light'), indigo: v('accent-indigo') },
  status: { danger: v('status-danger'), warning: v('status-warning'), success: v('status-success') },
};

export const gradient = { primary: v('gradient-primary'), success: v('gradient-success') };

export const shadow = { sm: v('shadow-sm'), md: v('shadow-md'), lg: v('shadow-lg') };

// Radius is theme-independent, so it stays as plain measures.
export const radius = { xs: '0.25rem', sm: '0.375rem', md: '0.5rem', lg: '0.75rem', xl: '1rem', pill: '999px', round: '50%' };

// Alpha overlay via color-mix so it tracks the (themed) var. Accepts a var()
// token OR a raw hex (e.g. a per-tool color). alpha(color.accent.primary, 0.15)
// -> "color-mix(in srgb, var(--tc-accent-primary) 15%, transparent)".
export const alpha = (cssColor, a) => `color-mix(in srgb, ${cssColor} ${+(a * 100).toFixed(4)}%, transparent)`;

const tokens = { color, gradient, radius, shadow, alpha };
export default tokens;
